import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody} from 'components/card';

const ArticleCard = ({postTitle, postContent, permanlink, translations}) => (
  <Card className="border-0 faq-card">
    <CardBody className="p-4">
      <div className="d-flex align-items-start mb-1">
        <i className="icon icon-file-text text-muted mr-2 mt-2"/>
        <span className="display-4 font-light">{postTitle}</span>
      </div>
      <p dangerouslySetInnerHTML={{__html: postContent}}></p>
      <a href={permanlink}>{translations.readMore}</a>
    </CardBody>
  </Card>
);

ArticleCard.propTypes = {
  postTitle: PropTypes.string.isRequired,
  postContent: PropTypes.string.isRequired,
  permanlink: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    readMore: PropTypes.string.isRequired
  }).isRequired
};

export default memo(ArticleCard);
